module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    staticClass: "searchbar-found",
    attrs: {
      "media-list": "",
      "id": "contacts-list"
    }
  }, [_c('div', {
    staticClass: "showSmallScreenOnly"
  }, _vm._l((_vm.contacts), function(group, key) {
    return _c('ul', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        key: contact.id,
        staticClass: "testTap boxRequest swipeout"
      }, [_c('div', {
        staticClass: "item-content swipeout-content"
      }, [_c('div', {
        staticClass: "item-inner",
        on: {
          "click": function($event) {
            return _vm.contactDetail(contact)
          }
        }
      }, [_c('div', {
        staticClass: "row",
        staticStyle: {
          "margin-left": "0px",
          "margin-right": "0px"
        }
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))]), _vm._v(" "), _c('div', {
        staticClass: "item-after"
      }, [_vm._v(_vm._s(contact.zoneCode))])]), _vm._v(" "), _c('div', {
        staticClass: "item-subtitle"
      }, [_vm._v(_vm._s(contact.name))])])]), _vm._v(" "), _c('div', {
        staticClass: "swipeout-actions-right"
      }, [_c('a', {
        staticClass: "swipeout-create action3",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.editContact(contact)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.$t('common.edit_label')) + "\n              ")]), _vm._v(" "), _c('a', {
        staticClass: "swipeout-delete action4",
        attrs: {
          "href": "#",
          "delete": ""
        },
        on: {
          "click": function($event) {
            return _vm.removeContact(contact)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.$t('common.rm_label')) + "\n              ")])])])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly"
  }, _vm._l((_vm.contacts), function(group, key) {
    return _c('ul', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        key: contact.id,
        staticClass: "testTap boxRequest swipeout"
      }, [_c('div', {
        staticClass: "item-content",
        on: {
          "click": function($event) {
            return _vm.contactDetail(contact)
          }
        }
      }, [_c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))])]), _vm._v(" "), _c('div', {
        staticClass: "item-title contactItem"
      }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('div', {
        staticClass: "item-after",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [_vm._v(_vm._s(contact.zoneCode))]), _vm._v(" "), _c('div', {
        staticClass: "item-media button-swipe-out",
        staticStyle: {
          "margin-right": "50px"
        }
      }, [_c('button', {
        staticClass: "button-big button-bank-account boxRequest",
        attrs: {
          "title": _vm.editlabel
        },
        on: {
          "click": function($event) {
            return _vm.editContact(contact)
          }
        }
      }, [_c('i', {
        staticClass: "icon-edit icon icon-float-sub-button"
      })]), _vm._v(" "), _c('button', {
        staticClass: "button-big button-bank-account boxRequest",
        attrs: {
          "title": _vm.removelabel,
          "delete": ""
        },
        on: {
          "click": function($event) {
            return _vm.removeContact(contact)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle button-delete",
        staticStyle: {
          "margin-bottom": "0.5%",
          "color": "red"
        }
      })])])])])
    })], 2)
  }), 0)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f23bd0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f23bd0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactsPage/CMContactList.vue
// module id = 1690
// module chunks = 2